import React, { useState, useEffect } from "react";
import "./imageUploadModal.css";
import axios from "axios";

const ImageUploadModal = ({
  isOpen,
  onClose,
  onInsert,
  initialData = {},
  isEditMode = false,
}) => {
  const [file, setFile] = useState(null);
  const [alt, setAlt] = useState("");
  const [attribution, setAttribution] = useState("");
  const [existingSrc, setExistingSrc] = useState("");

  useEffect(() => {
    setAlt(initialData?.alt || "");
    setAttribution(initialData?.attribution || "");
    setExistingSrc(initialData?.src || "");
    setFile(null);
  }, [initialData]);

  const handleUpload = async () => {
    if (!alt.trim()) {
      alert("Alt text is required for accessibility.");
      return;
    }

    // File validation if uploading a new image
    if (file) {
      const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
      const allowedTypes = ["image/jpeg", "image/png", "image/webp"];

      if (file.size > MAX_FILE_SIZE) {
        alert("Image must be smaller than 2MB.");
        return;
      }

      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG, PNG, and WebP images are supported.");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await axios.post("/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        const finalSrc = `${process.env.REACT_APP_AWS_S3_IMAGE_URL}${res.data.file}`;

        console.log("Calling onInsert with image data:", { src: finalSrc, alt, attribution });

        onInsert({ src: finalSrc, alt, attribution });
        onClose();
      } catch (err) {
        console.error("Upload error", err);
        alert("Error uploading image.");
      }

      return;
    }

    // No new file: reuse existing image
    if (existingSrc) {
      onInsert({ src: existingSrc, alt, attribution });
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="image-upload-modal">
      <div className="modal-content">
        <h3>{isEditMode ? "Edit Image" : "Insert Image"}</h3>
        <input type="file" accept="image/*" onChange={(e) => setFile(e.target.files[0])} />
        <input
          type="text"
          placeholder="Alt Text *"
          value={alt}
          onChange={(e) => setAlt(e.target.value)}
        />
        <input
          type="text"
          placeholder="Attribution (optional)"
          value={attribution}
          onChange={(e) => setAttribution(e.target.value)}
        />
        {file ? (
          <img src={URL.createObjectURL(file)} alt="preview" className="preview" />
        ) : existingSrc ? (
          <img src={existingSrc} alt="preview" className="preview" />
        ) : null}
        <div className="modal-buttons">
          <button
            onClick={handleUpload}
            disabled={!alt.trim() || (!file && !existingSrc)}
          >
            {isEditMode ? "Update" : "Insert"}
          </button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ImageUploadModal;
